<template>
    <div>

        <Head :title="user.name || user.username" />
        <div class="flex items-center mb-6">
            <h1 class="text-2xl font-bold mr-4">{{ user.name || user.username }}</h1>
            <img v-if="user.photo" :src="user.photo" class="w-10 h-10 rounded-full" />
        </div>

        <div class="bg-white rounded-md shadow p-6 max-w-3xl">
            <div class="grid grid-cols-2 gap-4">
                <div>
                    <label class="text-xs text-gray-500">Email</label>
                    <div class="mt-1">{{ user.email }}</div>
                </div>
                <div>
                    <label class="text-xs text-gray-500">Username</label>
                    <div class="mt-1">{{ user.username }}</div>
                </div>
                <div>
                    <label class="text-xs text-gray-500">Role</label>
                    <div class="mt-1">{{ user.role_name ?? '—' }}</div>
                </div>
                <div>
                    <label class="text-xs text-gray-500">Admin</label>
                    <div class="mt-1">{{ user.is_admin ? 'Yes' : 'No' }}</div>
                </div>
                <div>
                    <label class="text-xs text-gray-500">Last Password Change</label>
                    <div class="mt-1">{{ user.last_password_change ?? '—' }}</div>
                </div>
                <div>
                    <label class="text-xs text-gray-500">Employee ID</label>
                    <div class="mt-1">{{ user.employee_record_id ?? '—' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Head } from '@inertiajs/inertia-vue3'
    import Layout from '@/Shared/Layout'

    export default {
        layout: Layout,
        props: {
            user: Object,
        },
    }
</script>
